import u from "./internal/_arity.mjs";
import m from "./internal/_curry1.mjs";
import t from "./internal/_curry2.mjs";
import i from "./internal/_curryN.mjs";
var _ = /* @__PURE__ */ t(function(r, o) {
  return r === 1 ? m(o) : u(r, i(r, [], o));
});
export {
  _ as default
};
